<div class="ticket-history-tab">
  <!-- Loading Indicator -->
  @if (requestIsInProgress && (!historyData || historyData.length === 0)) {
    <div
      class="ticket-history__loading">
      <div class="ticket-spinner" role="status" aria-label="Loading history">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <!-- Timeline -->
  @if (historyData && historyData.length > 0) {
    <div class="history-timeline">
      <div class="timeline-line"></div>
      <div class="timeline-events">
        @for (event of historyData; track event; let last = $last) {
          <div class="timeline-event" [class.timeline-event-last]="last">
            <div class="event-icon" [ngClass]="getEventIconClass(event.action)">
              <mat-icon class="icon">{{ getEventIcon(event.action) }}</mat-icon>
            </div>
            <div class="event-content">
              <div class="event-header">
                <div class="event-user-action">
                  <span class="event-user">{{ event.user }}</span>
                  <span class="event-separator">•</span>
                  <span class="event-action">{{ formatAction(event.action) }}</span>
                </div>
                <span class="event-timestamp">{{ formatEventTime(event.timestamp) }}</span>
              </div>
              @if (event.details) {
                <div class="event-description">
                  {{ event.details }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Load More Button -->
  @if (showLoadMoreOption) {
    <div class="load-more-wrapper">
      <button
        type="button"
        class="load-more-btn"
        (click)="loadMore()"
        [disabled]="requestIsInProgress"
        >
        @if (!requestIsInProgress) {
          Load More
        } @else {
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span>Loading...</span>
        }
      </button>
    </div>
  }

  <!-- Empty State -->
  @if (!requestIsInProgress && (!historyData || historyData.length === 0)) {
    <div class="empty-state">
      <mat-icon class="empty-icon">history</mat-icon>
      <p class="empty-text">No activity yet</p>
      <p class="empty-subtext">Ticket history will appear here</p>
    </div>
  }
</div>
